import {Observable} from 'rxjs';
import {Configuration} from '@app/marketplace/products/_models/product.interface';
import {DefaultProjectorFn, MemoizedSelector} from '@ngrx/store';

export class PaginationSelectorModel<T> {
  selectLoading: MemoizedSelector<object, boolean, DefaultProjectorFn<boolean>>;
  selectItems: MemoizedSelector<object, T[], DefaultProjectorFn<T[]>>;
  selectPageSize: MemoizedSelector<object, number, DefaultProjectorFn<number>>;
  selectPageNo: MemoizedSelector<object, number, DefaultProjectorFn<number>>;
  selectTotalPage: MemoizedSelector<object, number, DefaultProjectorFn<number>>;
  selectTotalData: MemoizedSelector<object, number, DefaultProjectorFn<number>>;
  selectCount: MemoizedSelector<object, number, DefaultProjectorFn<number>>;
  selectConfiguration: MemoizedSelector<object, Configuration, DefaultProjectorFn<Configuration>>;
  constructor(selectLoading, selectItems, selectPageSize, selectPageNo, selectTotalPage, selectTotalData, selectCount) {
    this.selectLoading = selectLoading;
    this.selectItems = selectItems;
    this.selectPageSize = selectPageSize;
    this.selectPageNo = selectPageNo;
    this.selectTotalPage = selectTotalPage;
    this.selectTotalData = selectTotalData;
    this.selectCount = selectCount;
  }
}

export class ConfigurationPagedSelectorModel<T> extends PaginationSelectorModel<T> {
  selectConfiguration: MemoizedSelector<object, Configuration, DefaultProjectorFn<Configuration>>;
  constructor(selectLoading, selectItems, selectPageSize, selectPageNo, selectTotalPage, selectTotalData, selectCount, selectConfiguration) {
    super(selectLoading, selectItems, selectPageSize, selectPageNo, selectTotalPage, selectTotalData, selectCount);
    this.selectConfiguration = selectConfiguration;
  }
}
